import React, { useState } from "react";
import styles from "./Row.module.sass";

import Control from "./Control";
import Icon from "../../../../components/Icon";
import Actions from "../../../../components/Actions";
import Confirm from "../../../../components/Confirm";
import Modal from "../../../../components/Modal";
import { UseApi } from "../../../../hooks/use-api";
import {
	RaffleDelete,
	RaffleUpdate,
} from "../../../../Services/lib/nfttemplates";

import raffle from "../../../../i11/Raffle";
import { useUser } from "../../../../context";
import { UseDisclosure } from "../../../../hooks/use-disclosure";
import TemplateModal from "../../../NewProduct/TemplateModal";
import DetailRaffle from "./Detail";

const Row = ({ item, onEdit, getData }) => {
	const {
		isOpen: isOpenDetail,
		onOpen: onOpenDetail,
		onClose: onCloseDetail,
	} = UseDisclosure();
	const [visibleDelete, setVisibleDelete] = useState(false);
	const [statusChange, setStatusChange] = useState(false);
	const { locale } = useUser();

	const [{ isLoading }, deleteRaffle] = UseApi({
		service: RaffleDelete,
		successMsg: "Success",
	});
	const [{ isLoading: loadingUpdate }, updateRaffle] = UseApi({
		service: RaffleUpdate,
		successMsg: "Success",
	});

	const actions = [
		{
			title: "Change Status",
			icon: "reload",
			action: () => {},
		},
		{
			title: "Edit title & description",
			icon: "edit",
			action: () => onEdit(),
		},
		{
			title: "Delete forever",
			icon: "trash",
			action: () => setVisibleDelete(true),
		},
	];

	return (
		<>
			<div className={styles.row}>
				<div className={styles.col}></div>
				<div className={styles.col} onClick={() => onOpenDetail()}>
					<div className={styles.item}>
						<div className={styles.preview}>
							<img
								src={
									item.image ||
									"/images/content/product-pic-1.jpg"
								}
								alt="Raffle"
							/>
						</div>
						<div className={styles.details}>
							<div className={styles.product}>{item.name}</div>
							<div className={styles.link}>
								{item.description}
							</div>
							<div className={styles.date}>
								<Icon name="star" size="20" />
								{item.description}
							</div>
						</div>
					</div>

					<Actions
						className={styles.actions}
						classActionsHead={styles.actionsHead}
						items={actions}
					/>
				</div>
				<div className={styles.col}>
					<div className={styles.price}>{item.status}</div>
				</div>
				<div className={styles.col}>
					{item.endDate}
					<Control
						className={styles.control}
						onEdit={onEdit}
						onDelete={() => setVisibleDelete(true)}
						onChangeStatus={() => setStatusChange(true)}
					/>
				</div>
			</div>

			<TemplateModal visible={isOpenDetail} onClose={onCloseDetail}>
				{isOpenDetail && <DetailRaffle data={item} />}
			</TemplateModal>
			<Modal
				visible={visibleDelete}
				onClose={() => setVisibleDelete(false)}
			>
				<Confirm
					title={raffle[locale].delete_desc}
					onCancel={() => {
						setVisibleDelete(false);
					}}
					onConfirm={async () => {
						const res = await deleteRaffle(item._id);
						if (res) {
							setVisibleDelete(false);
							getData();
						}
					}}
					isLoading={isLoading}
				></Confirm>
			</Modal>

			<Modal
				visible={statusChange}
				onClose={() => setStatusChange(false)}
			>
				<Confirm
					title={`${raffle[locale].change_status_desc} ${
						item.status === "OPEN"
							? raffle[locale].draft
							: raffle[locale].open
					}`}
					onCancel={() => {
						setStatusChange(false);
					}}
					onConfirm={async () => {
						const res = await updateRaffle({
							_id: item._id,
							status: item.status === "OPEN" ? "DRAFT" : "OPEN",
						});
						if (res) {
							setStatusChange(false);
							getData();
						}
					}}
					isLoading={loadingUpdate}
				></Confirm>
			</Modal>
		</>
	);
};

export default Row;
